import React from 'react';
import "../styles.scss";
import aboutIcon from '../assets/about.png';
import githubIcon from '../assets/github.png';
import stackoverflowIcon from '../assets/stackoverflow.png';
import linkedInIcon from '../assets/linkedin.png';
import mediumIcon from '../assets/medium.png';
import { useLanguage } from '../context/LanguageContext';

const links = [
    {
        icon: githubIcon,
        title: "GitHub",
        link: "https://github.com/abraaoan",
        description: "Code, experiments and repositories"
    },
    {
        icon: stackoverflowIcon,
        title: "StackOverflow",
        link: "https://stackoverflow.com/users/1826898/abraaoan",
        description: "Technical answers and community profile"
    },
    {
        icon: linkedInIcon,
        title: "LinkedIn",
        link: "https://www.linkedin.com/in/abraaoan/",
        description: "Professional profile and contact"
    },
    {
        icon: mediumIcon,
        title: "Medium",
        link: "https://medium.com/@abraaoan",
        description: "Writing and ideas about development"
    }
];

const About = () => {
    const { t } = useLanguage();

    return (
        <section className="about-section">
            <h1 className="text-wrap">{t.about.title}</h1>
            <div className='row align-items-center g-4 about-hero'>
                <div className="col-lg-7">
                    <p className="text-white about-intro">{t.about.intro}</p>
                    <p className="text-white-50 about-copy">{t.about.copy}</p>
                    <div className="about-focus-group">
                        {t.about.focusAreas.map((item) => (
                            <span className="about-focus-pill" key={item}>{item}</span>
                        ))}
                    </div>
                </div>
                <div className="col-lg-5 text-center">
                    <div className="about-illustration-card">
                        <img className='about-illustration' src={aboutIcon} alt={t.about.imageAlt} />
                    </div>
                </div>
            </div>

            <div className="row g-4 about-principles-row">
                {t.about.principles.map((item) => (
                    <div className="col-lg-4" key={item.title}>
                        <article className="about-principle-card h-100">
                            <h2 className="about-principle-title">{item.title}</h2>
                            <p className="text-white-50 mb-0">{item.description}</p>
                        </article>
                    </div>
                ))}
            </div>

            <div className='row g-4 about-links-row'>
                <div className="col-lg-4">
                    <article className="about-contact-card h-100">
                        <p className="about-contact-eyebrow">{t.about.contactEyebrow}</p>
                        <h2 className="about-contact-title">{t.about.contactTitle}</h2>
                        <p className="text-white-50 mb-4">{t.about.contactDescription}</p>
                        <a className="btn btn-light" href="https://www.linkedin.com/in/abraaoan/" target="_blank" rel="noopener noreferrer">{t.about.contactCta}</a>
                    </article>
                </div>
                <div className="col-lg-8">
                    <div className='row g-3 text-white justify-content-start'>
                        {links.map((page, index) => (
                            <div className='col-md-6' key={page.title}>
                                <a className='about-link-card' href={page.link} target="_blank" rel="noopener noreferrer" aria-label={`${t.about.openProfileLabelPrefix} ${page.title}`}>
                                    <div className='about-link-icon-wrap'>
                                        <img src={page.icon} className='followIcon' alt={`${page.title} icon`} />
                                    </div>
                                    <div>
                                        <div className='about-link-title'>{page.title}</div>
                                        <div className='about-link-description'>{t.about.links[index].description}</div>
                                    </div>
                                </a>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
